import React, { useState } from "react";
import CustomScrollCalendar from "./CustomScrollCalendar";

const AppointmentPage = () => {
  const morningSlots = [
    "10:00 AM", "11:00 AM", "12:00 PM",
    "01:00 PM", "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM",
  ];

  const [selectionMode, setSelectionMode] = useState("single");
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedDates, setSelectedDates] = useState<Date[]>([]);
  const [appliedDates, setAppliedDates] = useState<Date[]>([]);
  const [selectedSession, setSelectedSession] = useState<string>("");
  const [selectedFromTime, setSelectedFromTime] = useState<string>("");
  const [selectedToTime, setSelectedToTime] = useState<string>("");

  const handleDateSelect = (date: Date) => {
    if (selectionMode === "single") {
      setSelectedDate(date);
    } else {
      const exists = selectedDates.find(d => d.toDateString() === date.toDateString());
      if (exists) {
        setSelectedDates(selectedDates.filter(d => d.toDateString() !== date.toDateString()));
      } else {
        setSelectedDates([...selectedDates, date]);
      }
    }
  };

  const getTimeSlots = () => morningSlots;

  const resetTimeSlots = () => {
    setSelectedFromTime("");
    setSelectedToTime("");
    setSelectedDate(null);
setSelectedDates([]);
setSelectedFromTime("");
setSelectedToTime("");
setSelectedSession("");
  };

  const isValidTimeRange = () => {
    if (selectedSession === "halfDay" || selectedSession === "fullDay") return true;
    const slots = getTimeSlots();
    return (
      selectedFromTime &&
      selectedToTime &&
      slots.indexOf(selectedFromTime) < slots.indexOf(selectedToTime)
    );
  };

  const handleApply = () => {
    const datesToApply = selectionMode === "single" ? [selectedDate] : selectedDates;
    if (datesToApply.length === 0 || datesToApply.includes(null)) {
      alert("Please select date(s).");
      return;
    }

    let from = selectedFromTime;
    let to = selectedToTime;

    if (selectedSession === "halfDay") {
      from = "10:00 AM";
      to = "12:00 PM";
    } else if (selectedSession === "fullDay") {
      from = "10:00 AM";
      to = "05:00 PM";
    }

    if (!from || !to || !isValidTimeRange()) {
      alert("Please select a valid time range.");
      return;
    }

    const formattedDates = datesToApply.map(d => d?.toDateString()).join(", ");
    alert(`Leave Applied On:\nDate(s): ${formattedDates}\nTime: ${from} - ${to}`);

    setAppliedDates([
      ...appliedDates,
      ...datesToApply.filter((date): date is Date => date !== null)
    ]);
    setSelectedDate(null);
    setSelectedDates([]);
    setSelectedFromTime("");
    setSelectedToTime("");
    setSelectedSession("");
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4 text-success text-center">Apply for Leave</h2>

      <div className="mb-4">
        <label className="form-label fw-semibold">Select Mode:</label>
        <select style={{width:'600px',margin:'auto'}}
          className="form-select"
          value={selectionMode}
          onChange={(e) => {
            const mode = e.target.value;
            setSelectionMode(mode);
            setSelectedDate(null);
            setSelectedDates([]);

            if (mode === "multiple") {
              setSelectedSession("fullDay");
              setSelectedFromTime("10:00 AM");
              setSelectedToTime("05:00 PM");
            } else {
              setSelectedSession("");
              setSelectedFromTime("");
              setSelectedToTime("");
            }
          }}
        >
          <option value="single">Single Day</option>
          <option value="multiple">Multiple Days</option>
        </select>
      </div>

      <div className="mb-4 border rounded p-3 bg-light shadow-sm">
        <CustomScrollCalendar
          onDateSelect={handleDateSelect}
          appliedDates={appliedDates}
          selectedDates={selectionMode === "multiple" ? selectedDates : selectedDate ? [selectedDate] : []}
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-semibold">Select Session:</label>
        <select style={{width:'600px',margin:'auto'}}
          className="form-select"
          value={selectedSession}
          onChange={(e) => {
            const session = e.target.value;
            setSelectedSession(session);
            if (session === "halfDay") {
              setSelectedFromTime("10:00 AM");
              setSelectedToTime("12:00 PM");
            } else if (session === "fullDay") {
              setSelectedFromTime("10:00 AM");
              setSelectedToTime("05:00 PM");
            } else {
              resetTimeSlots();
            }
          }}
          disabled={selectionMode === "multiple"}
        >
          <option value="">Select Session</option>
          <option value="halfDay">Half Day</option>
          <option value="fullDay">Full Day</option>
          <option value="custom">Custom Time</option>
        </select>
      </div>

      {selectedSession === "custom" && (
        <div className="row mb-4">
          <div className="col-md-6">
            <label className="form-label">From Time:</label>
            <select
              className="form-select"
              value={selectedFromTime}
              onChange={(e) => setSelectedFromTime(e.target.value)}
            >
              <option value="">From</option>
              {morningSlots.map((slot) => (
                <option key={slot} value={slot}>{slot}</option>
              ))}
            </select>
          </div>
          <div className="col-md-6">
            <label className="form-label">To Time:</label>
            <select
              className="form-select"
              value={selectedToTime}
              onChange={(e) => setSelectedToTime(e.target.value)}
            >
              <option value="">To</option>
              {morningSlots.map((slot) => (
                <option key={slot} value={slot}>{slot}</option>
              ))}
            </select>
          </div>
        </div>
      )}

      <div className="text-center">
        <button className="btn btn-success px-4 py-2" onClick={handleApply} style={{width:'600px'}}>
          Apply Leave
        </button>
      </div>
    </div>
  );
};

export default AppointmentPage;
